"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _YearnInvestor_deps, _YearnInvestor_opportunities;
Object.defineProperty(exports, "__esModule", { value: true });
exports.YearnInvestor = void 0;
const providers_1 = require("@ethersproject/providers");
const sdk_1 = require("@yfi/sdk");
const lodash_1 = require("lodash");
const filter_1 = __importDefault(require("lodash/filter"));
const web3_1 = __importDefault(require("web3"));
const constants_1 = require("./constants");
const YearnOpportunity_1 = require("./YearnOpportunity");
class YearnInvestor {
    constructor({ chainAdapter, dryRun, providerUrl, network = 1 }) {
        _YearnInvestor_deps.set(this, void 0);
        _YearnInvestor_opportunities.set(this, void 0);
        const httpProvider = new web3_1.default.providers.HttpProvider(providerUrl);
        const jsonRpcProvider = new providers_1.JsonRpcProvider(providerUrl);
        const web3 = new web3_1.default(httpProvider);
        __classPrivateFieldSet(this, _YearnInvestor_deps, Object.freeze({
            chainAdapter,
            contract: new web3.eth.Contract(constants_1.ssRouterAbi, constants_1.ssRouterContractAddress),
            dryRun,
            web3,
            yearnSdk: new sdk_1.Yearn(network, { provider: jsonRpcProvider }),
        }), "f");
        __classPrivateFieldSet(this, _YearnInvestor_opportunities, [], "f");
    }
    async initialize() {
        await __classPrivateFieldGet(this, _YearnInvestor_deps, "f").yearnSdk.ready;
        __classPrivateFieldSet(this, _YearnInvestor_opportunities, (await __classPrivateFieldGet(this, _YearnInvestor_deps, "f").yearnSdk.vaults.get()).map((vault) => new YearnOpportunity_1.YearnOpportunity(__classPrivateFieldGet(this, _YearnInvestor_deps, "f"), vault)), "f");
    }
    async findAll() {
        return __classPrivateFieldGet(this, _YearnInvestor_opportunities, "f");
    }
    async findByOpportunityId(opportunityId) {
        return (0, lodash_1.find)(await this.findAll(), (opp) => opp.positionAsset.assetId === opportunityId);
    }
    async findByUnderlyingAssetId(assetId) {
        return (0, filter_1.default)(await this.findAll(), { underlyingAsset: { assetId } });
    }
}
exports.YearnInvestor = YearnInvestor;
_YearnInvestor_deps = new WeakMap(), _YearnInvestor_opportunities = new WeakMap();
